import { render, staticRenderFns } from "./AskExperience.vue?vue&type=template&id=7bbcfd1c&scoped=true&"
import script from "./AskExperience.vue?vue&type=script&lang=ts&"
export * from "./AskExperience.vue?vue&type=script&lang=ts&"
import style0 from "./AskExperience.vue?vue&type=style&index=0&id=7bbcfd1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbcfd1c",
  null
  
)

export default component.exports